import { useState } from "react";
import { Award, ShieldCheck } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";
import { CERTIFICATIONS } from "@/data/certifications";

export default function CertificationsSection() {
  if (!CERTIFICATIONS || CERTIFICATIONS.length === 0) return null;
  return (
    <section className="section bg-white" data-testid="certifications-section">
      <div className="container-nago">
        <SectionHeading
          eyebrow="Certifications"
          title="Compliant, credentialed and audit-ready."
          description="Nago International operates with quality-management, statutory and industry certifications that reflect our commitment to reliability and compliance."
          align="center"
        />
        <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6">
          {CERTIFICATIONS.map((c, i) => (
            <CertCard key={`${c.name}-${i}`} cert={c} />
          ))}
        </div>
      </div>
    </section>
  );
}

function CertCard({ cert }) {
  const [imgError, setImgError] = useState(false);
  return (
    <div
      className="group bg-white border border-slate-200 rounded-2xl p-4 hover:border-[#1E3A8A] hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
      data-testid={`cert-card-${cert.name.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
    >
      <div className="aspect-[4/5] bg-white border border-slate-100 rounded-xl overflow-hidden flex items-center justify-center p-3">
        {cert.image && !imgError ? (
          <img
            src={cert.image}
            alt={cert.name}
            onError={() => setImgError(true)}
            className="max-h-full max-w-full object-contain"
            loading="lazy"
          />
        ) : (
          <div className="flex flex-col items-center justify-center text-center px-2">
            <div className="w-14 h-14 rounded-xl bg-[#1E3A8A]/10 flex items-center justify-center">
              <Award className="w-7 h-7 text-[#1E3A8A]" />
            </div>
            <div className="mt-3 text-[11px] uppercase tracking-widest text-slate-500 font-semibold">
              Certificate preview
            </div>
            <div className="mt-1 text-xs text-slate-500">
              Drop image at
              <br />
              <code className="text-[10px] break-all text-slate-600">{cert.image}</code>
            </div>
          </div>
        )}
      </div>
      <div className="mt-4 flex items-start gap-2">
        <ShieldCheck className="w-4 h-4 text-[#E30613] mt-0.5 shrink-0" />
        <div className="font-display font-semibold text-sm text-slate-900 leading-snug">
          {cert.name}
        </div>
      </div>
    </div>
  );
}
